"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.limiter = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */
var Config = {
  minHitInterval: 500,
  maxFailureCount: 3,
  maxHitAge: 1000 * 60 * 0.5,
  maxFailureAge: 1000 * 60 * 1,
  delayFactor: 2,
  maxDelay: 2000
};
var cache = {};
/**
 * limiter will take a set of params and a function to call.
 * If the params have been called recently, it will throw an error.
 * If the params have been called and failed to many times, it will throw an error.
 *
 * @param {*} params - The params to use as a key for the cache
 * @param function fn - The function to call fn(success, failure), where success and failure are functions to call when the function succeeds or fails.
 * @param {*} opt - Optional parameters
 * @param number opt.minHitInterval - The minimum time between hits in milliseconds, default is 500
 * @param number opt.maxFailureCount - The maximum number of failures before the limiter will throw an error, default is 3
 * @param number opt.maxHitAge - The maximum age of a hit in milliseconds, default is 30000
 * @param number opt.maxFailureAge - The maximum age of a failure in milliseconds, default is 60000
 * @param number opt.delayFactor - The factor to multiply the delay by, default is 2
 * @param number opt.maxDelay - The maximum delay in milliseconds, default is 2000
 */

var limiter = function limiter(params, fn) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var config = _objectSpread(_objectSpread({}, Config), opt);

  var now = Date.now(); // build cache key

  var keys = Object.keys(params).sort();
  var cacheKey = "";

  var _iterator = _createForOfIteratorHelper(keys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      cacheKey += "-".concat(key, "-").concat(JSON.stringify(params[key]));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!cacheKey) {
    throw "Limiter requires at least one parameter";
    return;
  } // get cache entry


  var entry = cache[cacheKey];

  if (!entry) {
    entry = {
      hits: [],
      failures: []
    };
    cache[cacheKey] = entry;
  } // filter out old hits


  if (Array.isArray(entry.hits)) {
    entry.hits = entry.hits.filter(function (hit) {
      return hit > now - config.maxHitAge;
    });
  } else {
    entry.hits = [];
  } // filter out old failures


  if (Array.isArray(entry.failures)) {
    entry.failures = entry.failures.filter(function (failure) {
      return failure > now - config.maxFailureAge;
    });
  } else {
    entry.failures = [];
  } // add new hit


  entry.hits.push(now); // calculate delay

  var lastHit = null;
  var delay = 0;

  var _iterator2 = _createForOfIteratorHelper(entry.hits),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var hit = _step2.value;

      if (lastHit) {
        var diff = hit - lastHit;

        if (diff < config.minHitInterval) {
          if (delay === 0) {
            delay = 1000;
          } else {
            delay = delay * config.delayFactor;
          }
        }
      }

      lastHit = hit;
    } // check max failure count

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (entry.failures.length >= config.maxFailureCount) {
    console.error("Limiter: max failure count reached", cacheKey, entry);
    throw "Limiter max failure count exceeded";
    return;
  } // check min hit interval


  if (delay > config.maxDelay) {
    console.error("Limiter: min interval exceeded and max delay reached", cacheKey, delay);
    throw "Limiter min hit interval exceeded and max delay reached";
    return;
  } else if (delay > 0) {
    console.warn("Limiter: delaying", delay, cacheKey, entry);
  }

  var onSuccess = function onSuccess() {
    // reset failures
    var entry = cache[cacheKey];

    if (entry) {
      entry.failures = [];
      cache[cacheKey] = entry;
    }
  };

  var onFailure = function onFailure() {
    // record failure
    var entry = cache[cacheKey];

    if (entry) {
      if (Array.isArray(entry.failures)) {
        entry.failures.push(now);
      }

      cache[cacheKey] = entry;
    }
  };

  return new Promise(function (resolve, reject) {
    if (delay > 0) {
      if (entry.timeout) {
        // this maybe needed in react to prevent out of order updates
        // to a consuming component
        console.warn("Limiter: already running for ", cacheKey, "ignoring");
        return;
      }

      entry.timeout = setTimeout(function () {
        entry.timeout = null;
        console.log("Limiter: calling function with delay", entry);
        resolve(fn(onSuccess, onFailure));
      }, delay);
    } else {
      resolve(fn(onSuccess, onFailure));
    }
  });
};

exports.limiter = limiter;